import React, { useEffect, useRef } from 'react';

import { renderTurnstile } from '@/utils/turnstile';

type TurnstileProps = {
  onToken: (token: string) => void;
};

const Turnstile = ({ onToken }: TurnstileProps) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const onTokenRef = useRef(onToken);
  onTokenRef.current = onToken;

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return undefined;

    let remove: (() => void) | undefined;
    let cancelled = false;

    renderTurnstile(element, (token) => onTokenRef.current(token)).then(
      (cleanup) => {
        if (cancelled) cleanup();
        else remove = cleanup;
      },
    );

    return () => {
      cancelled = true;
      remove?.();
    };
  }, []);

  return <div ref={elementRef} className="turnstile" />;
};

export default Turnstile;
